// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"149":"ffbbe5f09e2d5502e43e","537":"6dfe691041e36fef9811"}[chunkId] + ".js";
};